import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Context } from '../shared/services/context.service';

@Injectable({
  providedIn: 'root'
})
export class RccTraitement {

  constructor(private http: HttpClient,) { }


    addNewTreatments(typeCorrespondant) {
        return this.http.post(Context.apiUrl + 'treatmentRCC/', typeCorrespondant);
    }

    updateTreatments(typeCorrespondant,id) {
        return this.http.put(Context.apiUrl + 'treatmentRCC/'+id , typeCorrespondant);
    }


    getAllTreatments(id) {
        return this.http.get(Context.apiUrl + 'treatmentRCC/'+ id);
    }
 
    getOneRccById(id) {
        return this.http.get(Context.apiUrl + 'treatmentRCC/get/'+ id);
    }
 



}
